export * from "./InfoText";
